"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _text = require("@mmc/text");
var _editorialContentGrid = _interopRequireDefault(require("../styles/editorial-content-grid.css"));
var _imageWrapper = _interopRequireDefault(require("./image-wrapper"));
var _textBlockWrapper = _interopRequireDefault(require("./text-block-wrapper"));
var _ctaWrapper = _interopRequireDefault(require("./cta-wrapper"));
var _editorialContentGrid2 = _interopRequireDefault(require("./editorial-content-grid.props/editorial-content-grid.defaultProps"));
var _editorialContentGrid3 = _interopRequireDefault(require("./editorial-content-grid.props/editorial-content-grid.propTypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var dataUtils = new _mmcDataUtilities["default"]();
var renderEmptyString = dataUtils.renderEmptyString,
  handleNestedProp = dataUtils.handleNestedProp;
var GridCard = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(GridCard, _React$Component);
  function GridCard() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = GridCard.prototype;
  _proto.getColumnWidth = function getColumnWidth(index) {
    var modulo = 3;
    if ((index + 1) % modulo === 0) {
      return 'col-md-6';
    }
    return 'col-md-3';
  };
  _proto.render = function render() {
    var _this = this;
    var _this$props = this.props,
      cards = _this$props.cards,
      theme = _this$props.theme,
      disclaimerData = _this$props.disclaimerData;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, cards.map(function (card, i) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: theme['col-xs-12'] + " " + theme[_this.getColumnWidth(i)] + " " + theme.marginBottom80 + " " + _editorialContentGrid["default"].cardWrapper,
        key: i
      }, handleNestedProp(card, 'card.image.image') !== null && handleNestedProp(card, 'card.image.image') !== ' ' && /*#__PURE__*/_react["default"].createElement(_imageWrapper["default"], {
        image: card.image,
        theme: theme
      }), renderEmptyString(card.description) !== ' ' && /*#__PURE__*/_react["default"].createElement(_textBlockWrapper["default"], {
        text: card.description,
        theme: theme,
        index: i,
        disclaimerData: disclaimerData
      }), renderEmptyString(card.link) !== ' ' && /*#__PURE__*/_react["default"].createElement(_ctaWrapper["default"], {
        link: card.link,
        theme: theme
      }));
    }));
  };
  return GridCard;
}(_react["default"].Component);
exports["default"] = GridCard;
GridCard.displayName = 'GridCard';
GridCard.defaultProps = {
  cards: _editorialContentGrid2["default"].columns[0]
};